<div class="calculator-container">

  <div class="calculator-search" style="margin-top: 0px; padding-top: 0px">
    <div class="calculator-search__label">
      Symbol
    </div>
    <div class="search">
      <dx-autocomplete
        (keydown)="this.keyDownSearch.emit($event);"
        (onItemClick)="selectStock($event.itemData)"
        [(value)]="_stockName"
        [dataSource]="instruments"
        [elementAttr]="{ class: 'instrument-select', style: 'transform:none; width: auto;background-color: #3A3A3A; border:none !important' }"
        [showClearButton]="true"
        class="search-field"
        [placeholder]="autocompletePlaceholder"
        searchMode="StartsWith"
        valueExpr="nameAndExchange"
      >
        <div
          *dxTemplate="let item of 'item'"
          class="instrument-select-item favourites-instrument-select-item"
        >
          <div class="instrument-select-item__name-container">
            <div class="name-and-exchange">{{item.nameAndExchange}}</div>
            <div class="stock-type">
              {{getStockType(item)}} - {{item.region}}
            </div>
          </div>
          <div class="instrument-select-item__company-container">
            <div
              class="company"
              title="{{item.company}}"
            >
              {{item.company}}
            </div>
          </div>
        </div>
      </dx-autocomplete>
    </div>

    <button
      class="advanced-search"
      (click)="openAdvancedSearch()"
      statistic
      [statisticElementName]="'Calculator search button click'"
      id="surfaceButtons"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.2204 13.2204C13.371 13.0699 13.371 12.8257 13.2204 12.6752L11.2653 10.7201C11.9939 9.86702 12.4338 8.75999 12.4338 7.55021C12.4338 4.8531 10.2473 2.66667 7.55022 2.66667C4.85312 2.66667 2.66669 4.8531 2.66669 7.55021C2.66669 10.2473 4.85312 12.4337 7.55022 12.4337C8.75997 12.4337 9.86699 11.9939 10.72 11.2653L12.6752 13.2204C12.8258 13.371 13.0699 13.371 13.2204 13.2204Z" fill="white"/>
      </svg>
    </button>


  </div>


  <ng-content></ng-content>

  <dx-popup
    class="advanced-search-popup"
    [width]="advancedSearchPopupSize.width"
    [height]="advancedSearchPopupSize.height"
    [dragEnabled]="false"
    [closeOnOutsideClick]="true"
    [(visible)]="advancedSearchVisible"
    titleTemplate="title"
  >
    <div *dxTemplate="let data of 'title'">
      <span class="dx-popup-title__text">Advanced search</span>
      <div class="dx-popup-title__close" (click)="advancedSearchVisible = false">
        <img src="iv-live/assets/icons/chart-service/charts-icons/close.svg">
      </div>
    </div>
    <div *dxTemplate="let data of 'content'" style="overflow: auto">
      <iv-live-advanced-search
        (addSymbols)="selectAdvancedSearchStock($event)"
        [hasMultipleChoice]="false"
        [isFuture]="isFutures"
        [isCalc]="true"
      ></iv-live-advanced-search>
    </div>
  </dx-popup>
</div>
